<template>
	<section v-if="items.length" class="faq-section">
		<div class="row faq">
			<div class="columns column12">
				<div class="columns column12">
					<h2>{{ header }}</h2>
					<div class="collapse-container">
						<collapse v-for="item in items" :key="item.ID" :header="item.question" :content="item.answer" />
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});

const config = useRuntimeConfig();

if (props.items.length) {
	const faqSchema = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		about: {
			'@type': 'Hotel',
			'@id': `${config.public.siteUrl}#hotel`,
		},
		mainEntity: props.items.map((item) => ({
			'@type': 'Question',
			name: item.question,
			acceptedAnswer: {
				'@type': 'Answer',
				text: item.answer,
			},
		})),
	};

	useHead({
		script: [
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify(faqSchema),
			},
		],
	});
}
</script>

<style lang="scss" scoped>
.faq-section {
	background-color: var(--primary-background-color);
	padding: 0 0 100px;

	h2 {
		margin-bottom: 50px;
	}

	.collapse-container {
		background-color: #fff;
	}
}
</style>
